import { jsx as _jsx } from "react/jsx-runtime";
import { Children, forwardRef, isValidElement, useMemo, } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { TableLoadingSkeleton } from './table-loading-skeleton';
import './skeleton.scss';
function countColumns(children) {
    return Children.toArray(children).filter((child) => isValidElement(child) && child.type === Column).length;
}
const AppDataTableBase = forwardRef(function AppDataTable({ loading, loadingIcon, pt, children, ...rest }, ref) {
    const columnCount = useMemo(() => {
        const counted = countColumns(children);
        return counted > 0 ? counted : 5;
    }, [children]);
    const skeletonLoadingIcon = loading ? (_jsx(TableLoadingSkeleton, { columns: columnCount, rows: rest.rows ?? 8, striped: rest.stripedRows ?? true, showPaginator: Boolean(rest.paginator) })) : null;
    return (_jsx(DataTable, { ref: ref, ...rest, loading: loading, loadingIcon: loadingIcon ?? skeletonLoadingIcon, pt: {
            ...pt,
            loadingOverlay: {
                className: 'app-datatable-skeleton-overlay p-component-overlay',
                ...pt?.loadingOverlay,
            },
            loadingIcon: {
                className: 'app-datatable-skeleton-content',
                ...pt?.loadingIcon,
            },
        }, children: children }));
});
AppDataTableBase.displayName = 'AppDataTable';
export const AppDataTable = AppDataTableBase;
export { DataTable };
